import script from "./StageResults.vue?vue&type=script&setup=true&lang=js"
export * from "./StageResults.vue?vue&type=script&setup=true&lang=js"

import "./StageResults.vue?vue&type=style&index=0&id=ffd12fe4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffd12fe4"]])

export default __exports__